import { CssBaseline } from '@material-ui/core';
import { Switch } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';

import { Navbar, PrivateRoute, Topbar } from 'src/components';
import { type RootState } from 'src/store';
import { type Route } from 'src/models';
import { privateRoutes } from './routes';
import { useSelector } from 'react-redux';
import NotFound from './NotFound';
import useStyles from './styles';

function Dashboard() {
	const classes = useStyles();
	const { enqueueSnackbar } = useSnackbar();
	const [isMobileNavOpen, setMobileNavOpen] = useState(false);
	const notification = useSelector((state: RootState) => state.notification);

	useEffect(() => {
		if (notification.open) {
			enqueueSnackbar(notification.message, {
				variant: notification.variant,
			});
		}
	}, [notification]);

	return (
		<div className={classes.root}>
			<CssBaseline />

			<Topbar
				handleDrawerOpen={() => {
					setMobileNavOpen(true);
				}}
				open={isMobileNavOpen}
			/>

			<Navbar
				onMobileClose={() => {
					setMobileNavOpen(false);
				}}
				openMobile={isMobileNavOpen}
			/>

			<div className={classes.content}>
				<Switch>
					{privateRoutes.map((route: Route, index: number) => (
						<PrivateRoute
							component={route.component}
							exact
							key={index}
							path={route.path}
							rights={route.rights}
						/>
					))}

					<PrivateRoute component={NotFound} />
				</Switch>
			</div>
		</div>
	);
}

export default Dashboard;
